import React from "react";
import { useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Accordion } from "react-bootstrap";

function PatientSidebar() {
  const navigate = useNavigate();

  const [sidenavopen, setSideNavOpen] = useState(true);
  const style = `
    .accordion-button {
          padding: unset !important;
          background-color: #f6f6f6;
          padding: .6rem .5rem;
              margin-top: .9rem;
    height: 2.7rem !important;
    max-width: unset !important;
    display: flex;
    flex-direction: row;
    border: unset;
    }

    .accordion-button:focus{
    background-color: #cacaca;
    }

    .accordion-button:hover{
    background-color: #cacaca;
    }

    .accordion-item{
      border: unset !important;
    }

    .accordion-button::after {
    flex-shrink: 0;
    width: 0.8rem;
    height: 0.8rem;
    margin-left: auto;
    margin-right: 1rem;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: cover;
    transition: var(--bs-accordion-btn-icon-transition);
}

  .accordion-button:not(.collapsed) {
    color: unset;
    background-color: unset;
    box-shadow: unset;
}

  .accordion-button:focus {
    z-index: 3;
    outline: 0;
    box-shadow: unset;
}
  `;

  return (
    <>
      <style>{style}</style>
      <div style={{ height: "100%" }} className="row gx-0">
        <nav
          container
          className={sidenavopen ? "sidebar col-md-2" : "collapsed sidebar"}
        >
          <div class="sidebar-top-wrapper">
            <div class="sidebar-top">
              <div class="logo__wrapper">
                <div style={{ width: "5rem", maxWidth: "9rem" }}>
                  <img
                    style={{}}
                    src="./Images/Logo.png"
                    alt="Logo"
                    class="logo-small"
                  />
                </div>
              </div>
            </div>

            <button
              onClick={() => setSideNavOpen(!sidenavopen)}
              className="expand-btn"
            >
              <i
                class="fa-regular fa-square-caret-left "
                style={{ color: "#3cc245" }}
              ></i>
            </button>
            <div class="TvZMhVkOCp"></div>
          </div>
          <div class="sidebar-links">
            <h2 class="vis-head">Patient</h2>
            <ul>
              <li>
                <a
                  href="/PatientProfile"
                  className="accordion-fhjhkkn d-flex align-items-center gap-4 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <i class="fa-solid fa-square-poll-horizontal"></i>
                  <p className="div-atagcolor">My Health</p>
                </a>
              </li>

              <li className="mb-2">
                <a
                  href="/PatientAppointments"
                  className="accordion-fhjhkkn d-flex align-items-center gap-4 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <i class="fa-solid fa-square-poll-horizontal"></i>
                  <p className="div-atagcolor">Appointments</p>
                </a>
              </li>

              {/* <li className="mb-2">
                <a
                  href="#"
                  className="accordion-fhjhkkn d-flex align-items-center gap-4 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <i class="fa-solid fa-square-poll-horizontal"></i>
                  <p className="div-atagcolor">
                    My Health
                  </p>
                </a>
              </li> */}

              <li className="mb-2">
                <a
                  href="/PatientLabReports"
                  className="accordion-fhjhkkn d-flex align-items-center gap-4 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <i class="fa-solid fa-calendar-check"></i>
                  <p className="div-atagcolor">Lab Tests & Reports</p>
                </a>
              </li>

              <li className="mb-2">
                <a
                  href="/PatientPrescription"
                  className="accordion-fhjhkkn d-flex align-items-center gap-4 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  {/* <i class="fa-solid fa-diagram-next"></i> */}
                  <i class="fa-solid fa-user-group"></i>
                  <p className="div-atagcolor">Prescriptions</p>
                </a>
              </li>

              <li className="mb-2">
                <a
                  href="/Treatments"
                  className="accordion-fhjhkkn d-flex align-items-center gap-4 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <i class="fa-solid fa-user-group"></i>
                  <p className="div-atagcolor">Treatment</p>
                </a>
              </li>

              <li className="mb-2">
                <a
                  href="#"
                  className="accordion-fhjhkkn d-flex align-items-center gap-4 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  {/* <i class="fa-solid fa-diagram-next"></i> */}
                  <i class="fa-solid fa-user-group"></i>
                  <p className="div-atagcolor">Help & Support</p>
                </a>
              </li>

              {/* <li className="mb-2">
              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-2 pt-1 pb-1">
                    <div className="d-flex align-items-center gap-4">
                    <i class="fa-solid fa-hospital"></i>
                      <span
                        style={{
                          fontSize: "0.8rem",
                          color: "#757575",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        Clinic
                      </span>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <span
                      style={{ width: "100%" }}
                      class="pr-drop-a d-flex flex-column"
                    >
                      <a
                        style={{
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                          height: "2rem",
                          color: "#757575",
                          fontSize: "0.8rem",
                          marginBottom: "1rem",
                        }}
                        href="/Registration"
                      >
                        <span>
                          <i class="fa-solid fa-sheet-plastic"></i>
                        </span>
                        <span>Clinic Details</span>
                      </a>
                      <a
                        style={{
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                          height: "2rem",
                          color: "#757575",
                          fontSize: "0.8rem",
                          marginBottom: "1rem",
                        }}
                        href="/Branches"
                      >
                        <span>
                          <i class="fa-solid fa-folder-plus"></i>
                        </span>
                        <span>Create Details</span>
                      </a>
                    </span>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </li>

            <li className="mb-2">
              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-2 pt-1 pb-1">
                    <div className="d-flex align-items-center">
                      <i class="fa-solid fa-calendar-days"></i>
                      <span
                        style={{
                          fontSize: "0.8rem",
                          color: "#757575",
                          display: "flex",
                          alignItems: "center",
                          marginLeft: "1.5rem",
                        }}
                      >
                        Modules
                      </span>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <span
                      style={{ width: "100%" }}
                      class="pr-drop-a d-flex flex-column"
                    >
                      <a
                        style={{
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                          height: "2rem",
                          color: "#757575",
                          fontSize: "0.8rem",
                          marginBottom: ".5rem",
                        }}
                        href="1"
                      >
                        <span>
                          <i class="fa-solid fa-arrow-right"></i>
                        </span>
                        <span>Add</span>
                      </a>
                      <a
                        style={{
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                          height: "2rem",
                          color: "#757575",
                          fontSize: "0.8rem",
                          marginBottom: ".5rem",
                        }}
                        href="/EmployeesView"
                      >
                        <span>
                          <i class="fa-solid fa-arrow-right"></i>
                        </span>
                        <span>View</span>
                      </a>
                    </span>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </li>

            <li className="mb-1">
              <Accordion>
                <Accordion.Item eventKey="0" style={{ overflow: "hidden" }}>
                  <Accordion.Header className="accordion-fhjhkkn ps-2 pt-1 pb-1">
                    <div className="d-flex align-items-center">
                      <i class="fa-solid fa-person"></i>
                      <span
                        style={{
                          fontSize: "0.8rem",
                          color: "#757575",
                          display: "flex",
                          alignItems: "center",
                          marginLeft: "1.5rem",
                        }}
                      >
                        Sub-Modules
                      </span>
                    </div>
                  </Accordion.Header>
                  <Accordion.Body>
                    <span
                      style={{ width: "100%" }}
                      class="pr-drop-a d-flex flex-column"
                    >
                      <a
                        style={{
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                          height: "2rem",
                          color: "#757575",
                          fontSize: "0.8rem",
                          marginBottom: ".5rem",
                        }}
                        href="1"
                      >
                        <span>
                          <i class="fa-solid fa-arrow-right"></i>
                        </span>
                        <span>In Patient</span>
                      </a>
                      <a
                        style={{
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                          height: "2rem",
                          color: "#757575",
                          fontSize: "0.8rem",
                          marginBottom: ".5rem",
                        }}
                        href="1"
                      >
                        <span>
                          <i class="fa-solid fa-arrow-right"></i>
                        </span>
                        <span>Out Patient</span>
                      </a>
                      <a
                        style={{
                          textDecoration: "none",
                          display: "flex",
                          alignItems: "center",
                          height: "2rem",
                          color: "#757575",
                          fontSize: "0.8rem",
                        }}
                        href="1"
                      >
                        <span>
                          <i class="fa-solid fa-arrow-right"></i>
                        </span>
                        <span>Add Patient</span>
                      </a>
                    </span>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </li> */}
            </ul>
          </div>

          <div class="sidebar-links bottom-links">
            <ul>
              <li className="">
                {/* <a
                href="#"
                className="accordion-fhjhkkn d-flex align-items-center gap-4 p-2 rounded-2 mt-2 overflow-hidden"
              >
                <i class="fa-solid fa-table-columns"></i>
                <p className="div-atagcolor">
                  Documentation
                </span>
              </a> */}
              </li>

              <li className="">
                <a
                  href="/SignIn"
                  className="accordion-fhjhkkn d-flex align-items-center gap-4 p-2 rounded-2 mt-2 overflow-hidden"
                >
                  <i
                    class="fa-solid fa-right-from-bracket"
                    style={{ color: "#D55F5A" }}
                  ></i>
                  <span style={{ color: "#D55F5A", fontSize: "0.8rem" }}>
                    Log Out
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </nav>
        <div
          style={{
            display: "flex",
            flexGrow: "1",
            padding: "unset",
            height: "100%",
          }}
          className="col-md-10"
        >
          <div className="col-12 g-0 div-colcon">
            <div className="div-TM1vTuWchY flex-jt-sb">
              <div className="d-flex justify-content-between div-W1ShPmHBDd">
                <form class="search-frm" action="">
                  <input
                    placeholder="Search here..."
                    class="in-HNSyBtMsov"
                    type="text"
                  />
                </form>

                <div className="d-flex">
                  <a href="#" class="btn-oZUxFnIW1j">
                    <i class="fa-solid fa-bell"></i>
                  </a>
                  <a href="#" class="btn-oZUxFnIW1j">
                    <i class="fa-solid fa-gear"></i>
                  </a>

                  <div class="btn-oZUxFnIW1j">
                    <i class="fa-solid fa-circle-user"></i>
                  </div>
                </div>
              </div>
              <header id="hamburger-hd">
                <input type="checkbox" id="menyAvPaa" />
                <label id="burger" for="menyAvPaa">
                  <div></div>
                  <div></div>
                  <div></div>
                </label>
                <nav id="meny">
                  <div style={{ height: "100%" }} class="d-flex flex-column">
                    <div class="div-mV3nDcsCXh">
                      <div
                        style={{
                          width: "5rem",
                          maxWidth: "5rem",
                          height: "5rem",
                        }}
                      >
                        <img
                          src="/Images/Logo.png"
                          style={{}}
                          alt="Logo"
                          class="logo-small"
                        />
                      </div>
                      <span style={{ fontSize: "12px", color: "#888" }}>
                        Powered by PelicanRX
                      </span>
                      <span
                        style={{ fontSize: "16px", fontWeight: "600" }}
                      ></span>
                    </div>
                    <div class="TvZMhVkOCp"></div>
                    <div class="div-XbccJyGpRY">
                      <div class="d-flex flex-column div-Yb0Usyx31B">
                        <span class="spn-HX8Z7l2ITc">Patient</span>
                        <ul class="ul-WvVKfbP6Pb">
                          <li>
                            <a
                              href="/Dashboard"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Dashboard"
                            >
                              <i class="fa-solid fa-square-poll-horizontal"></i>
                              <span class="link hide">Dashboard</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/ProviderProfile.html"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Dashboard"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">Clinics</span>
                            </a>
                          </li>

                          <li>
                            <a
                              href="/ProviderPayments.html"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Payments"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">Modules</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/ProviderFavoriteTechnicians.html"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Technician"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">Subscription</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="/ProviderClient.html"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Technician"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">Analytics & Reports</span>
                            </a>
                          </li>

                          <li>
                            <a
                              href="#dashboard"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Settings"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">Support Tickets</span>
                            </a>
                          </li>
                          <li>
                            <a
                              href="#settings"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Help"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">User Management</span>
                            </a>
                          </li>

                          <div
                            style={{ margin: ".5rem auto" }}
                            class="TvZMhVkOCp"
                          ></div>

                          <li>
                            <a
                              href="#"
                              data-toggle="tooltip"
                              data-placement="right"
                              data-bs-original-title="Logout"
                            >
                              <i class="fa-solid fa-table-columns"></i>
                              <span class="link hide">Logout Account</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </nav>
              </header>
            </div>
            <div id="dash-con">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default PatientSidebar;
